import { useEffect, useRef, useState } from "react";
import { SavedBeerFlight } from "../../data/types";
import { getFlightHistory } from "../../services/flightHistory";
import "./FlightHistory.scss";

interface FlightHistoryProps {
  onSelectFlight: (flight: SavedBeerFlight) => void;
  refreshKey?: number;
}

const formatDate = (iso: string): string => {
  return new Date(iso).toLocaleDateString("sv-SE", {
    day: "numeric",
    month: "short",
    hour: "2-digit",
    minute: "2-digit",
  });
};

const FlightHistory: React.FC<FlightHistoryProps> = ({
  onSelectFlight,
  refreshKey = 0,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const [history, setHistory] = useState<SavedBeerFlight[]>([]);
  const panelRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    setHistory(getFlightHistory());
  }, [refreshKey, isOpen]);

  useEffect(() => {
    if (!isOpen) return;

    const handleClickOutside = (e: MouseEvent | TouchEvent) => {
      if (
        panelRef.current &&
        !panelRef.current.contains(e.target as Node)
      ) {
        setIsOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    document.addEventListener("touchstart", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
      document.removeEventListener("touchstart", handleClickOutside);
    };
  }, [isOpen]);

  const handleSelect = (flight: SavedBeerFlight) => {
    onSelectFlight(flight);
    setIsOpen(false);
  };

  return (
    <div className="flight-history" ref={panelRef}>
      <button
        className="flight-history__toggle"
        onClick={() => setIsOpen((open) => !open)}
        aria-label="Visa sparade flights"
        aria-expanded={isOpen}
      >
        <img src="/history.svg" alt="" />
      </button>

      {isOpen && (
        <div className="flight-history__panel">
          <h3>Sparade flights</h3>
          {history.length === 0 ? (
            <p className="flight-history__empty">
              Inga sparade flights ännu. Fyll alla fem platser för att spara.
            </p>
          ) : (
            <ul className="flight-history__list">
              {history.map((flight) => (
                <li key={flight.id}>
                  <button
                    className="flight-history__item"
                    onClick={() => handleSelect(flight)}
                  >
                    <span className="flight-history__date">
                      {formatDate(flight.createdAt)}
                    </span>
                    <span className="flight-history__beers">
                      {flight.beers.map((b) => b.name).join(", ")}
                    </span>
                  </button>
                </li>
              ))}
            </ul>
          )}
        </div>
      )}
    </div>
  );
};

export default FlightHistory;
